import React from 'react'
import classNames from 'classnames'

import styles from './styles.module.scss'

import type { LntModalFooterProps } from './types'

export const LntModalFooter: React.FC<LntModalFooterProps> = ({ className: outerClassName, children, ...props }) => {
  const className: string = classNames(outerClassName, styles.lntModalFooter)

  return (
    <div
      { ...props }
      className={ className }
    >
      { children }
    </div>
  )
}
